import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { IIndustry } from 'models/industry';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  industries: IIndustry[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const AddCompany: React.FC<Props> = ({ open, loading, industries, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation()
  let industriesOptions = industries.map((industry) => {
    return { value: industry.id, label: industry.name };
  });
  let basicFields: IFormField[] = [
    {
      name: 'Name',
      label: t('T_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_name'),
      required: true,
      internalLabel: true
    },
    {
      name: 'NameAr',
      label: t('T_name') + ' ' + t('T_in_arabic'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_name') + ' ' + t('T_in_arabic'),
      internalLabel: true
    },
    {
      name: 'IndustryId',
      label: t('T_industry_name'),
      type: InputTypes.SELECT,
      placeholder: t('T_industry_name'),
      options: industriesOptions,
      multiple: false,
      internalLabel: true,
      required: true
    },
    {
      name: 'IsCorporate',
      label: t('T_is_corporate'),
      type: InputTypes.CHECKBOX,
      internalLabel: true,
    },
    {
      name: 'Logo',
      label: t('T_Logo'),
      type: InputTypes.FILE,
      internalLabel: true
    },
    {
      name: 'CertificateName',
      label: t('T_certificate_name') || 'Certificate Name',
      type: InputTypes.TEXT,
      placeholder: t('T_enter_certificate_name') || 'Enter Certificate Name',
      internalLabel: true
    },
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_company')}
      maxWidth="lg"
      children={<Grid container p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Grid>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddCompany;